module.exports = __webpack_public_path__ + "fonts/SFUIText-Heavy.1aeed097.ttf";